const benchmarkScoreEnumerators = {
    scoreType: [
        'disclosure',
        'engagement',
    ],
};

export default benchmarkScoreEnumerators;
